import { MiddlewareAPIResponse } from '../../middlewareapiresponse';
import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { GetBannerToneDto } from '../../../dto/getbannerdetails/getbannertonedto';

export interface GetBannerDetailsResponse extends MiddlewareAPIResponse
{
    getListOfGetBannerDtos(): GetBannerToneDto[];
}

export class GetBannerDetailsResponseDtoImpl extends MiddlewareDtoImpl implements GetBannerDetailsResponse
{
    private getBannerDetailsRespnseDtos : GetBannerToneDto[];

    getListOfGetBannerDtos(): GetBannerToneDto[]
    {
        return this.getBannerDetailsRespnseDtos;
    }
    setGetBannerDto(getBannerDetailsRespnseDtos: GetBannerToneDto[])
    {
        this.getBannerDetailsRespnseDtos = getBannerDetailsRespnseDtos;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/banner/getbannerdetails/getbannerdetailsresponse.tsx